var map = {
	"./dots.svg": 7663,
	"./icon-chevron-next.svg": 2860,
	"./icon-chevron-prev.svg": 5452,
	"./icon-drbl.svg": 7409,
	"./icon-link.svg": 8381,
	"./icon-mail.svg": 4852,
	"./icon-tg.svg": 8826,
	"./logo.svg": 3914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;